import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { installerMiseAJour } from "@/pwa/miseAJour";
import { verifierVersion } from "@/pwa/versionGate";
import "@/scss/main.scss";

// Montage IMMÉDIAT (26/09) : App Check démarre en arrière-plan et n'est plus
// attendu (avant : jusqu'à 2 s de script reCAPTCHA avant le 1er écran).
createApp(App).use(store).use(router).mount("#app");
// Nouvelle version appliquée d'elle-même, jamais pendant une histoire.
installerMiseAJour(router);
// A18 : un ancien build encore en cache se remplace dès le démarrage (une fois).
if (import.meta.env.PROD) {
  router.isReady().then(() => {
    if (router.currentRoute.value.name === "histoire-route") return;
    let session = null;
    try {
      session = window.sessionStorage;
    } catch {
      /* bloqué */
    }
    verifierVersion({ courante: __APP_VERSION__, url: `${import.meta.env.BASE_URL}version.json`, storage: session });
  });
}
